import { useMutation } from '@tanstack/react-query';

import { BulkUpdatePromoCodesByIdsPayload, bulkUpdatePromoCodesByIds } from '~/services/PromoService';

export default function useUpdatePromoCodeExpiry() {
  return useMutation({
    mutationFn: (payload: BulkUpdatePromoCodesByIdsPayload) => bulkUpdatePromoCodesByIds(payload),
  });
}
